import type { SupportedLanguage } from '../locales';

const homeHeroPromoByLanguage: Record<SupportedLanguage, string> = {
  en: [
    `Turn one Short into a global audience!`,
    `🔥Vevi Monster automatically translates, cleans audio, and lip-syncs it into any language — just $2🔥`,
  ].join('\n'),
  ru: [
    `Превратите один Short в видео для глобальной аудитории!`,
    `🔥Vevi Monster автоматически переведёт его, очистит звук и синхронизирует lip-sync на любом языке — всего за $2🔥`,
  ].join('\n'),
  es: [
    `Convierte un Short en contenido para una audiencia global.`,
    `🔥Vevi Monster lo traduce, limpia el audio y ajusta el lip-sync a cualquier idioma por solo $2🔥`,
  ].join('\n'),
  fr: [
    `Transformez un Short en contenu pour une audience mondiale.`,
    `🔥Vevi Monster le traduit, nettoie l'audio et synchronise les lèvres dans n'importe quelle langue pour seulement 2 $🔥`,
  ].join('\n'),
  de: [
    `Mach aus einem Short ein Video für ein weltweites Publikum.`,
    `🔥Vevi Monster übersetzt es automatisch, bereinigt den Ton und passt den Lip-Sync in jede Sprache an — für nur 2 $🔥`,
  ].join('\n'),
  it: [
    `Trasforma uno Short in contenuto per un pubblico globale.`,
    `🔥Vevi Monster lo traduce, pulisce l'audio e sincronizza il labiale in qualsiasi lingua a soli $2🔥`,
  ].join('\n'),
  pt: [
    `Transforme um Short em conteúdo para um público global.`,
    `🔥Vevi Monster traduz, limpa o áudio e faz o lip-sync em qualquer idioma por apenas $2🔥`,
  ].join('\n'),
  pl: [
    `Zamień jednego Shorta w materiał dla globalnej publiczności.`,
    `🔥Vevi Monster automatycznie go przetłumaczy, oczyści audio i dopasuje lip-sync w dowolnym języku — za jedyne 2 $🔥`,
  ].join('\n'),
  zh: [
    `让一条 Short 面向全球观众。`,
    `🔥Vevi Monster 可自动完成翻译、音频清理和口型同步，支持任何语言，只需 2 美元🔥`,
  ].join('\n'),
  ja: [
    `1本のShortを、世界に届くコンテンツへ。`,
    `🔥Vevi Monsterが翻訳、音声クリーンアップ、リップシンクまでをどの言語でも自動で行い、料金はたったの2ドル🔥`,
  ].join('\n'),
  ko: [
    `Short 하나로 전 세계 시청자에게 다가가세요.`,
    `🔥Vevi Monster가 번역, 음성 정리, 립싱크까지 어떤 언어로든 자동 처리하며 가격은 단 $2🔥`,
  ].join('\n'),
  ar: [
    `حوّل فيديو Short واحدًا إلى محتوى يصل إلى جمهور عالمي.`,
    `🔥يقوم Vevi Monster بالترجمة وتنظيف الصوت ومزامنة حركة الشفاه تلقائيًا إلى أي لغة مقابل 2$ فقط🔥`,
  ].join('\n'),
  bg: [
    `Превърнете един Short във видео за глобална аудитория.`,
    `🔥Vevi Monster автоматично го превежда, изчиства аудиото и прави lip-sync на всеки език — само за $2🔥`,
  ].join('\n'),
  hr: [
    `Pretvorite jedan Short u sadržaj za globalnu publiku.`,
    `🔥Vevi Monster ga automatski prevodi, čisti zvuk i usklađuje lip-sync na bilo koji jezik — za samo 2 $🔥`,
  ].join('\n'),
  cs: [
    `Proměňte jeden Short ve video pro globální publikum.`,
    `🔥Vevi Monster ho automaticky přeloží, vyčistí zvuk a sladí lip-sync do jakéhokoli jazyka — jen za 2 $🔥`,
  ].join('\n'),
  da: [
    `Gør én Short klar til et globalt publikum.`,
    `🔥Vevi Monster oversætter automatisk, renser lyden og laver lip-sync på ethvert sprog — for kun 2 $🔥`,
  ].join('\n'),
  nl: [
    `Maak van één Short content voor een wereldwijd publiek.`,
    `🔥Vevi Monster vertaalt automatisch, maakt de audio schoon en doet de lip-sync in elke taal — voor slechts $2🔥`,
  ].join('\n'),
  et: [
    `Muuda üks Short sisuks ülemaailmsele publikule.`,
    `🔥Vevi Monster tõlgib selle automaatselt, puhastab heli ja sünkroonib huulte liikumise igasse keelde — vaid 2 $ eest🔥`,
  ].join('\n'),
  fi: [
    `Tee yhdestä Shortista sisältöä maailmanlaajuiselle yleisölle.`,
    `🔥Vevi Monster kääntää sen automaattisesti, siistii äänen ja synkronoi huuliliikkeet mille tahansa kielelle — vain 2 dollarilla🔥`,
  ].join('\n'),
  el: [
    `Μετέτρεψε ένα Short σε περιεχόμενο για παγκόσμιο κοινό.`,
    `🔥Το Vevi Monster μεταφράζει αυτόματα, καθαρίζει τον ήχο και συγχρονίζει τα χείλη σε οποιαδήποτε γλώσσα — μόνο με 2 $🔥`,
  ].join('\n'),
  hu: [
    `Egy Shortból globális közönségnek szóló videót készíthetsz.`,
    `🔥A Vevi Monster automatikusan lefordítja, megtisztítja a hangot és lip-syncet készít bármely nyelven — mindezt mindössze 2 dollárért🔥`,
  ].join('\n'),
  ga: [
    `Déan ábhar do lucht féachana domhanda as Short amháin.`,
    `🔥Aistríonn Vevi Monster é go huathoibríoch, glanann sé an fhuaim agus déanann sé lip-sync in aon teanga — ar $2 amháin🔥`,
  ].join('\n'),
  lv: [
    `Pārvērt vienu Short par saturu globālai auditorijai.`,
    `🔥Vevi Monster to automātiski iztulko, attīra audio un pielāgo lip-sync jebkurai valodai — tikai par 2 $🔥`,
  ].join('\n'),
  lt: [
    `Paverskite vieną Short turiniu pasaulinei auditorijai.`,
    `🔥Vevi Monster automatiškai jį išverčia, sutvarko garsą ir pritaiko lip-sync bet kuriai kalbai — tik už 2 $🔥`,
  ].join('\n'),
  mt: [
    `Ibdel Short wieħed f'kontenut għal udjenza globali.`,
    `🔥Vevi Monster jittraduċih awtomatikament, inaddaf l-awdjo u jqabbel il-lip-sync ma' kwalunkwe lingwa — għal $2 biss🔥`,
  ].join('\n'),
  ro: [
    `Transformă un Short în conținut pentru o audiență globală.`,
    `🔥Vevi Monster îl traduce automat, curăță audio-ul și face lip-sync în orice limbă — doar cu 2 $🔥`,
  ].join('\n'),
  sk: [
    `Premeňte jeden Short na video pre globálne publikum.`,
    `🔥Vevi Monster ho automaticky preloží, vyčistí zvuk a zosúladí lip-sync do akéhokoľvek jazyka — len za 2 $🔥`,
  ].join('\n'),
  sl: [
    `Spremenite en Short v vsebino za globalno občinstvo.`,
    `🔥Vevi Monster ga samodejno prevede, očisti zvok in uskladi lip-sync v katerem koli jeziku — za samo 2 $🔥`,
  ].join('\n'),
  sv: [
    `Gör en Short redo för en global publik.`,
    `🔥Vevi Monster översätter automatiskt, rensar ljudet och lägger lip-sync på valfritt språk — för bara 2 $🔥`,
  ].join('\n'),
};

export function getHomeHeroPromo(language: SupportedLanguage): string {
  return homeHeroPromoByLanguage[language] || homeHeroPromoByLanguage.en;
}
